import { z } from "zod";
import { ProfileItemSchema } from "@/schemas/profile/profile-item";
import { TaxonomyCountryItemSchema } from "@/schemas/taxonomy/taxonomy-country-item";

export const AccountItemSchema = z.object({
  Id: z.string(),
  Name: z.string().optional(),
  CountryId: z.string().optional(),
  Phone: z.string().optional(),
  CountryName: z.string().optional(),
  CurrencyId: z.string().optional(),
  VendorConnect: z.boolean().optional(),
  Email: z.string().optional(),
  Number: z.string().optional(),
  ParentId: z.string().optional(),
  ParentName: z.string().optional(),
  PaystandId: z.string().optional(),
  ReferralCode: z.string().optional(),
  ReferralCreditBalance: z.number().optional(),
  PrimaryContact: ProfileItemSchema.optional(),
  Country: TaxonomyCountryItemSchema.optional(),
  PrimaryContactId: z.string().optional(),
  PrimaryContactName: z.string().optional(),
  Address: z.string().optional(),
  AddressCity: z.string().optional(),
  AddressLine1: z.string().optional(),
  AddressLine2: z.string().optional(),
  AddressPostalCode: z.string().optional(),
  AddressStateOrProvince: z.string().optional(),
});

export type AccountItemType = z.infer<typeof AccountItemSchema>;
